import { useNewsAndGuidesDetailsPageData } from 'src/app/pages/newsAndGuides/details/pageContext';

type Result = ModelHookResult<{
	isGuide: boolean;
	showGuidesLink: boolean;
	urlBase: string;
	showSapCta: boolean;
}>;

export function usePageHeading(): Result {
	const {
		data: { hasGuides, details, countryCode },
	} = useNewsAndGuidesDetailsPageData();

	return {
		data: {
			isGuide: details.__typename === 'Guide',
			showGuidesLink: hasGuides,
			urlBase: `/l/${encodeURIComponent(countryCode)}`,
			showSapCta: details.__typename === 'Guide',
		},
	};
}
